import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface User {
  id: string
  username: string
  email: string
  full_name?: string
  role: string
  is_active: boolean
  created_at?: string
  updated_at?: string
}

interface AuthState {
  token: string | null
  user: User | null
  isAuthenticated: boolean
}

const initialState: AuthState = {
  token: localStorage.getItem('token'),
  user: JSON.parse(localStorage.getItem('user') || 'null'),
  isAuthenticated: !!localStorage.getItem('token'),
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action: PayloadAction<{ token: string; user: User | null }>) => {
      state.token = action.payload.token
      state.user = action.payload.user
      state.isAuthenticated = true
      localStorage.setItem('token', action.payload.token)
      if (action.payload.user) {
        localStorage.setItem('user', JSON.stringify(action.payload.user))
      }
    },
    setUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload
      state.isAuthenticated = true
      localStorage.setItem('user', JSON.stringify(action.payload))
    },
    /** Trình diễn: đặt vai trò không cần đăng nhập (tương đương đăng nhập trong bản production). */
    setDemoUser: (state, action: PayloadAction<string>) => {
      const role = action.payload
      const fullNames: Record<string, string> = {
        user: 'Phạm Thị Hồng Nhung',
        litigant: 'Phạm Thị Hồng Nhung',
        secretary: 'Nguyễn Thị Hương',
        judge: 'Trần Văn Bình',
        admin: 'Lê Văn Cường',
        chief_judge: 'Lê Văn Cường',
      }
      state.token = 'demo-token'
      state.user = {
        id: 'demo-user',
        username: role === 'user' || role === 'litigant' ? 'pham.nhung' : role === 'secretary' ? 'nguyen.huong' : role === 'judge' ? 'tran.binh' : 'le.cuong',
        email: role === 'user' || role === 'litigant' ? 'pham.nhung@email.vn' : role === 'secretary' ? 'nguyen.huong@toaan.vn' : role === 'judge' ? 'tran.binh@toaan.vn' : 'le.cuong@toaan.vn',
        full_name: fullNames[role] || role,
        role,
        is_active: true,
      }
      state.isAuthenticated = true
      localStorage.setItem('token', state.token)
      localStorage.setItem('user', JSON.stringify(state.user))
    },
    logout: (state) => {
      state.token = null
      state.user = null
      state.isAuthenticated = false
      localStorage.removeItem('token')
      localStorage.removeItem('user')
    },
  },
})

export const { setCredentials, setUser, setDemoUser, logout } = authSlice.actions
export default authSlice.reducer
